import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire4Screen = () => {
  const dispatch = useDispatch();
  const {questionnaires} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.IMPORTANT_INFORMATION);

  const onClickSubmit = () => {
    dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.ABOUT_SAXENDA}));
  };
  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiText variant="mdqTitle" mt={spacing.medium}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map(desc => (
          <UiText key={desc} fontSize="12px" mt={spacing.medium} px={spacing.mini} lineHeight="24px">
            {desc}
          </UiText>
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
